<script>
  // @ts-check
  import Rule from "../atoms/Rule.svelte";
  import Video from "./Video.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Represents a video playlist component.
   *
   * @component VideoPlaylist
   *
   * @param {Array<import("./Video.svelte")>} videos - The array of videos in the playlist.
   */
  export let videos = [];
</script>

<div {id} class={className}>
  {#each videos as video, index}
    <Video {...video} />
    {#if index !== videos.length - 1}
      <Rule class="my-7.5 block lg:my-10 xl:my-12.5" />
    {/if}
  {/each}
</div>
